import * as React from "react";
import { useApiMutation, usePageData } from "../utils/api";
import { useForm } from "react-hook-form";
import { Offcanvas } from "react-bootstrap";
import { makeModal } from "../utils/make_modal";
import { toast } from "react-toastify";

const useProjectDrawer = () =>
  makeModal(({ refetch, close, object }) => {
    const { post, saving } = useApiMutation();
    const { register, handleSubmit, reset } = useForm({ defaultValues: { name: "" } });

    const addProject = async (values: { name: string }) => {
      post("/projects", { project: values }).success(() => {
        refetch();
        close();
        reset();
        toast.success("Project created");
      });
    };

    return (
      <Offcanvas show={!!object} onHide={close} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{object?.id ? "Edit Item" : "Add New Item"}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <form onSubmit={handleSubmit(addProject)}>
            <div className="row">
              <div className="col-9">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Name"
                  {...register("name", { required: true })}
                />
              </div>

              <div className="col-3">
                <button type="submit" className="btn btn-primary w-100" disabled={saving}>
                  Create
                </button>
              </div>
            </div>
          </form>
        </Offcanvas.Body>
      </Offcanvas>
    );
  });

export const Projects = () => {
  const { data, refetch, unavailable } = usePageData();
  const ProjectDrawer = useProjectDrawer();
  if (unavailable) {
    return unavailable;
  }

  const { projects } = data;

  return (
    <div>
      <div className="container mt-4">
        <h2>Projects</h2>

        <div className="list-group mt-4 mb-4">
          {projects?.map((project) => (
            <div key={project.id}>
              <h5 className="mb-2">
                <a href={`/projects/${project.id}`}>{project.name}</a>
              </h5>
            </div>
          ))}
        </div>

        <button className="btn btn-primary btn-sm" onClick={() => ProjectDrawer.show()}>
          Add Project
        </button>

        <ProjectDrawer refetch={refetch} />
      </div>
    </div>
  );
};
